export const LOGIN_BASE_URL = "https://studvin.com/profile-api.studywin/public";

export const REGISTER_BASE_URL = "https://studvin.com/profile-api.studywin/public/api";

export const COMING_SOON_URL = "https://studvin.com:3000"
